import {SxProps} from '@/theme';

export const useSxLayout = (
  displayType = 'block',
): {mobile: SxProps; desktop: SxProps} => ({
  mobile: {display: {xs: displayType, md: 'none'}},
  desktop: {display: {xs: 'none', md: displayType}},
});
